module.exports = __webpack_public_path__ + "static/media/lost.f0e4bb23.png";